/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Nosubscriptions1Inputs */

const zh_billing_nosubscriptions1 = /** @type {(inputs: Billing_Nosubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无订阅记录`)
};

const en_billing_nosubscriptions1 = /** @type {(inputs: Billing_Nosubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No subscription records`)
};

const es_billing_nosubscriptions1 = /** @type {(inputs: Billing_Nosubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin registros de suscripción`)
};

/**
* | output |
* | --- |
* | "No subscription records" |
*
* @param {Billing_Nosubscriptions1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const billing_nosubscriptions1 = /** @type {((inputs?: Billing_Nosubscriptions1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Nosubscriptions1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_billing_nosubscriptions1(inputs)
	if (locale === "en") return en_billing_nosubscriptions1(inputs)
	return es_billing_nosubscriptions1(inputs)
});
export { billing_nosubscriptions1 as "billing_noSubscriptions" }